import React from 'react';
import PropTypes from 'prop-types';
import { localizeJsonLD } from '../helper';
import { SettingsContext } from '../../../hoc/Settings';

const JsonLD = ({ data }) => {
  const mainData = localizeJsonLD(data);
  const {
    domainSettings: { domain },
  } = React.useContext(SettingsContext);

  if (!mainData.id) {
    return null;
  }

  const formatted = {
    '@context': 'http://schema.org',
    '@type': 'EducationalOrganization',
    name: mainData.title,
    url: `www.${domain}`,
    logo: mainData.logo,
    image: mainData.cover_photo || mainData.logo,
    email: mainData.email,
    areaServed: mainData.location.city,
    address: {
      '@type': 'PostalAddress',
      addressLocality: mainData.city,
      streetAddress: `${mainData.location.city}, ${mainData.location.street} ${
        mainData.location.house_number
      }`,
      addressRegion: mainData.location.city,
      telephone: mainData.phone,
    },
    brand: {
      '@type': 'Brand',
      name: mainData.title,
    },
    contactPoint: {
      '@type': 'ContactPoint',
      email: mainData.email,
      telephone: mainData.phone,
      contactType: 'sales',
    },
  };

  if (mainData.raters_count) {
    formatted.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: mainData.rating,
      reviewCount: mainData.raters_count,
      bestRating: 5,
      worstRating: 0,
    };
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(formatted),
      }}
    />
  );
};

JsonLD.propTypes = {
  data: PropTypes.object,
};

JsonLD.defaultProps = {
  data: {},
};

export default JsonLD;
